import z from 'zod';

export const eventPrinterSchema = z.object({
  printerId: z.string().min(1, 'Printer is required'),
  name: z.string().min(1, 'Name is required'),
  status: z.string().min(1, 'Status is required'),
});
